import { SvgIconProps } from '@material-ui/core'
import React from 'react'

import Accessibility from '@material-ui/icons/Accessibility'
import AccessTime from '@material-ui/icons/AccessTime'
import AccountBalance from '@material-ui/icons/AccountBalance'
import AccountBalanceWallet from '@material-ui/icons/AccountBalanceWallet'
import AccountBox from '@material-ui/icons/AccountBox'
import AccountCircle from '@material-ui/icons/AccountCircle'
import AddIcCall from '@material-ui/icons/AddIcCall'
import AirportShuttle from '@material-ui/icons/AirportShuttle'
import BatteryFull from '@material-ui/icons/BatteryFull'
import Brightness5 from '@material-ui/icons/Brightness5'
import DirectionsSubway from '@material-ui/icons/DirectionsSubway'
import Explore from '@material-ui/icons/Explore'
import LocalShipping from '@material-ui/icons/LocalShipping'
import Map from '@material-ui/icons/Map'
import MyLocation from '@material-ui/icons/MyLocation'
import Place from '@material-ui/icons/Place'
import Power from '@material-ui/icons/Power'
import Public from '@material-ui/icons/Public'
import WbSunny from '@material-ui/icons/WbSunny'

const DynamicIcons = {
  AddIcCall,
  Accessibility,
  AccountBox,
  AccountCircle,
  AccountBalance,
  AccountBalanceWallet,
  AccessTime,
  Map,
  DirectionsSubway,
  MyLocation,
  AirportShuttle,
  LocalShipping,
  Place,
  Explore,
  Public,
  WbSunny,
  Brightness5,
  Power,
  BatteryFull,
} as const

export type DynamicIconsTypes = keyof typeof DynamicIcons

export const DynamicIconKeys = Object.keys(DynamicIcons) as DynamicIconsTypes[]

type DynamicIconProps = {
  icon: DynamicIconsTypes
}

export const DynamicIcon: React.FC<DynamicIconProps & SvgIconProps> = ({ icon, ...props }) => {
  const Icon = DynamicIcons[icon]

  if (!Icon) {
    return <span>Icon not found: {icon}</span>
  }
  return <Icon {...props} />
}
